@if (trialing) {
  <div
    class="mx-auto h-7 w-max rounded-t-xl bg-blue px-4 py-1 text-center text-sm font-medium text-white"
  >
    {{ 'product.dialog.currentlyInYourTrial' | transloco }}
  </div>
}
<div
  class="relative flex w-[390px] flex-col items-center gap-4 overflow-hidden rounded-2xl bg-white shadow-lg"
  [class.border-blue]="trialing"
  [class.border-2]="trialing"
  [class.border-grey-midGrey]="!trialing"
  [class.border]="!trialing"
  [class.mt-7]="!trialing"
>
  <p class="mt-5 flex items-center px-5 text-4xl font-semibold text-blue">
    {{ 'product.dialog.plans.' + planTranslationKey + '.name' | transloco }}
  </p>
  <p class="px-5 text-center text-sm">
    {{
      'product.dialog.plans.' + planTranslationKey + '.description' | transloco
    }}
  </p>
  <app-display-price-per-user
    class="px-5"
    [loading]="loading"
    [unitPrice]="unitPrice"
    [totalPriceWithoutTaxAndDiscount]="totalPriceWithoutTaxAndDiscount"
  ></app-display-price-per-user>
  <div class="w-full px-5">
    <app-topic-area-select
      [trialing]="trialing"
      [disabled]="loading"
      [preselected]="preselected"
      [selectedTopicAreaIds]="selectedTopicAreaIds()"
      (selectedTopicAreaIdsChanged)="onSelectedTopicAreaIdsChanged($event)"
    ></app-topic-area-select>
  </div>

  <div class="flex w-full flex-col gap-2 bg-grey-veryLightGrey p-5">
    <app-primary-button
      class="w-full"
      [text]="selectPlanCTA() | transloco"
      (buttonClicked)="onSelectButtonClick()"
    ></app-primary-button>
    <app-secondary-button
      class="w-full"
      [text]="'product.dialog.talkToSalesButton' | transloco"
      (buttonClicked)="onSalesButtonClick()"
    ></app-secondary-button>
  </div>
</div>
